import React, { Fragment } from "react";
// TODO: Undisable slices once bug fixed

//Converts raw value into day/night components and then re-combines them when they pass back up.
export const SettingsWrapper = Composed => props => <Composed
    disabled={props.disabled}
    value={{ day: (props.value & 0x7), night: ((props.value >>> 4) & 0x7) }}
    onChange={({ day, night }) => {
        props.onChange((day & 0x7) + ((night & 0x7) << 4));
    }} />

import { Row } from "../../DataTable.jsx";

export const DayNightWrapper = (EditorComponent, noPara = false) => props => {
    let bind = key => ({ disabled: props.disabled, value: props.value[key], onChange: ev => props.onChange(Object.assign({}, props.value, { [key]: ev.target.value })) });
    return <Fragment>
        <Row label="Day" noParagraph={noPara}>
            <EditorComponent {...bind("day") } />
        </Row>
        <Row label="Night" noParagraph={noPara}>
            <EditorComponent {...bind("night") } />
        </Row>
        {/* 
            * TODO: Undisable slices once bug fixed
        <Row label="">
            <button type="button" onClick={ () => location.href=`#/site/${getPanelHwaddr()}/slices` } className="btn btn-info btn-block" >Edit Day/Night Settings</button> 
        </Row>
        */}
    </Fragment>
}
